import { mergeAttributes, Node } from "@tiptap/core";
import _ from "lodash";

export const CustomButton = Node.create({
  name: "button",
  priority: 1000,

  group: "block",
  content: "inline*",
  draggable: true,

  addAttributes() {
    return {
      bgcolor: {
        default: "unset",
        parseHTML: (element) => element.style.bgcolor?.replace(/['"]+/g, ""),
        renderHTML: (attributes) => {
          return {
            style: `background-color: ${attributes["bgcolor"]}`,
          };
        },
      },
      color: {
        default: "unset",
        parseHTML: (element) => element.style.color?.replace(/['"]+/g, ""),
        renderHTML: (attributes) => {
          return {
            style: `color: ${attributes["color"]}`,
          };
        },
      },
      class: {
        default: null,
        renderHTML: (attributes) => {
          return {
            class: `${attributes.class}`,
          };
        },
      },
    };
  },

  addOptions() {
    return {
      HTMLAttributes: {},
    };
  },

  parseHTML() {
    return [{ tag: "button" }];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "button",
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
      0,
    ];
  },

  addCommands() {
    return {
      setButton:
        ({ content, ...options }) =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs: options,
            content: [
              {
                type: "text",
                text: content,
              },
            ],
          });
        },
    };
  },
});
